import { APICore } from "../apiCore";

const api = new APICore();

function getShowDetailPage(genreSlug: string, showSlug: string) {
  return api.get(`/genre/${ genreSlug }/show/${ showSlug }`);
}

function getShowAwards(genreSlug, showSlug) {
  return api.get(`/genre/${genreSlug}/show/${showSlug}/award`);
}

function getShowAwardCounts(genreSlug, showSlug) {
  return api.get(`/genre/${genreSlug}/show/${showSlug}/award`);
}


export { getShowDetailPage, getShowAwards, getShowAwardCounts };